import React, { useEffect, useRef, useState } from "react";
import "./AppHeader.css";
import logo from "../../assets/logo.png";
import { useAuth } from "../../context/AuthContext";
import { VERTICALS } from "../../constants/verticals";

import { useLocation, useNavigate } from "react-router-dom";
const AppHeader: React.FC = () => {
  const { user, userDetails, logout } = useAuth();
  const role = user?.role;

  const isAdmin = role === "Admin" || role === "CompanyAdmin";
  const isManager = role === "Manager";

  const normalizedRole = role?.toLowerCase() || "";
  const isPreSales = normalizedRole === "pre sales";
  const isExecutive =
    normalizedRole === "executive" ||
    normalizedRole === "pre sales";
  const isHR = normalizedRole.includes("hr");
  const canAccessSales = !isHR;
  const navigate = useNavigate();
  const location = useLocation();

  const settingsRef = useRef<HTMLDivElement | null>(null);
  const profileRef = useRef<HTMLDivElement | null>(null);

  const [settingsOpen, setSettingsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      if (
        settingsRef.current &&
        !settingsRef.current.contains(target)
      ) {
        setSettingsOpen(false);
      }

      if (
        profileRef.current &&
        !profileRef.current.contains(target)
      ) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  console.log('userdetails----------', userDetails);


  // console.log("userDetails", userDetails);
  return (
    <header className="app-header">
      {/* LEFT : LOGO */}
      <div className="header-left">
        <img onClick={() => navigate("/dashboard")} src={logo} alt="Hatchway ERP" className="logo" style={{ cursor: "pointer" }} />
      </div>

      {/* CENTER : MENU */}
      <nav className="header-center">
        {!isHR && (
          <span
            onClick={() => navigate("/dashboard")}
            className={`nav-link ${location.pathname.startsWith("/dashboard") ? "active" : ""}`}
          >
            Dashboard
          </span>
        )}



        {(isAdmin || isHR) && (
          <div className="nav-item">
            <span className={`nav-link ${location.pathname.startsWith("/hr") ? "active" : ""}`}>
              HR
            </span>
            <div className="dropdown-menu">
              <span onClick={() => navigate("/hr/users")}>Employee Master</span>
            </div>
          </div>
        )}
        {canAccessSales && (
          <div className="nav-item">
            <span
              className={`nav-link ${location.pathname.includes("/inquiries") ? "active" : ""
                }`}
            >
              Sales
            </span>
            <div className="dropdown-menu">
              {isAdmin
                ? VERTICALS.map(v => (
                  <span key={v.key} onClick={() => navigate(`/${v.key}/inquiries`)}>
                    Inquiry for  {v.label}
                  </span>
                ))
                : (
                  <span onClick={() => navigate(`/${user?.vertical_key}/inquiries`)}>
                    Inquiry for {user?.vertical_name}
                  </span>
                )}
            </div>
          </div>
        )}
        {canAccessSales && (
          <div className="nav-item">
            <span
              className={`nav-link ${location.pathname.includes("/followups") ? "active" : ""
                }`}
            >
              Sales Followup
            </span>

            <div className="dropdown-menu">
              {isAdmin
                ? VERTICALS.map(v => (
                  <span
                    key={`followup-${v.key}`}
                    onClick={() => navigate(`/${v.key}/followups`)}
                  >
                    Followup for {v.label}
                  </span>
                ))
                : (
                  <span
                    onClick={() =>
                      navigate(`/${user?.vertical_key}/followups`)
                    }
                  >
                    Followup for {user?.vertical_name}
                  </span>
                )}
            </div>
          </div>
        )}

        {(isAdmin || isManager || isExecutive || isPreSales) && (
          <div className="nav-item">
            <span
              className={`nav-link ${location.pathname.includes("/masters") ||
                location.pathname.includes("/payment-terms") ||
                location.pathname.includes("/stage") ||
                location.pathname.includes("/bulk-transfer")
                ? "active"
                : ""
                }`}
            >
              Masters
            </span>
            <div className="dropdown-menu">
              <span onClick={() => navigate("/masters/client")}>Clients</span>
              <span onClick={() => navigate("/masters/contact")}>
                Contact Directory
              </span>
              {!isPreSales && (
                <span onClick={() => navigate("/payment-terms")}>
                  Payment Terms
                </span>
              )}
              {isAdmin && (
                <span onClick={() => navigate("/stage")}>Stages</span>

              )}
              {isAdmin && (
                <span onClick={() => navigate("/bulk-transfer")}>Bulk Ownership Transfer</span>

              )}
            </div>
          </div>
        )}


        {(isAdmin || isManager || isExecutive) && !isPreSales && (
          <div className="nav-item">
            <span
              className={`nav-link ${location.pathname.includes("/reports") ||
                location.pathname.includes("/timelag-report")
                ? "active"
                : ""
                }`}
            >
              Reports
            </span>
            <div className="dropdown-menu grouped">
              {/* REPORT SECTION */}
              <div className="dropdown-section">
                <div className="dropdown-title">Reports</div>

                {isAdmin
                  ? VERTICALS.map(v => (
                    <span
                      key={`report-${v.key}`}
                      onClick={() => navigate(`/${v.key}/reports`)}
                    >
                      {v.label} Report
                    </span>
                  ))
                  : (
                    <span
                      onClick={() => navigate(`/${user?.vertical_key}/reports`)}
                    >
                      {user?.vertical_name} Report
                    </span>
                  )}
              </div>
              <div className="dropdown-section">
                <div className="dropdown-title">Contact Directory Reports</div>

                <span
                  onClick={() => navigate("/reports/contact-directory")}
                >
                  Source wise Reports
                </span>
                <span
                  onClick={() => navigate("/reports/contact-directory-assigned-to")}
                >
                 Assined to wise Reports
                </span>
                 <span
                  onClick={() => navigate("/reports/contact-directory-created-by")}
                >
                 Employee wise Reports
                </span>

                
              </div>
              {/* UNATTENDED SECTION */}
              <div className="dropdown-section">
                <div className="dropdown-title">Unattended Inquiries</div>

                {isAdmin
                  ? VERTICALS.map(v => (
                    <span
                      key={`unattended-${v.key}`}
                      onClick={() =>
                        navigate(`/${v.key}/reports/not-attended-30-days`)
                      }
                    >
                      {v.label} Unattended Inquiries
                    </span>
                  ))
                  : (
                    <span
                      onClick={() =>
                        navigate(`/${user?.vertical_key}/reports/not-attended-30-days`)
                      }
                    >
                      {user?.vertical_name} Unattended Inquiries
                    </span>
                  )}
              </div>


              {/* OPTIONAL: TIMELAG */}
              {isAdmin && (
                <div className="dropdown-section">
                  <div className="dropdown-title">Other</div>
                  <span onClick={() => navigate("/timelag-report")}>
                    TimeLag Report
                  </span>
                </div>
              )}
            </div>
          </div>
        )}




      </nav>

      {/* RIGHT : SETTINGS + PROFILE */}
      <div className="header-right">
        {isAdmin && (
          <div
            className="settings-wrapper"
            ref={settingsRef}
            onMouseEnter={() => setSettingsOpen(true)}
            onMouseLeave={() => setSettingsOpen(false)}
          >
            <button
              className="icon-btn"
              title="Settings"
              onClick={() => setSettingsOpen(prev => !prev)}
            >
              <i className="fas fa-cog"></i>
            </button>

            {settingsOpen && (
              <div className="settings-menu">
                <span
                  onClick={() => {
                    navigate("/company");
                    setSettingsOpen(false);
                  }}
                >
                  Company Details
                </span>

                <span
                  onClick={() => {
                    navigate("/company/settings");
                    setSettingsOpen(false);
                  }}
                >
                  Time Lag
                </span>
              </div>
            )}
          </div>
        )}




        <div
          className="profile-wrapper"
          ref={profileRef}
          onClick={() => setProfileOpen(prev => !prev)}
        >
          <div className="avatar">
            {(userDetails?.username?.[0] ||
              user?.user_username?.[0] ||
              user?.email?.[0] ||
              "U"
            ).toUpperCase()}
          </div>

          {profileOpen && (
            <div className="profile-menu">
              <span className="profile-name">
                {user?.user_username}
              </span>

              <span
                onClick={() => {
                  navigate("/profile");
                  setProfileOpen(false);
                }}
              >
                View Profile
              </span>

              <span
                onClick={() => {
                  navigate("/settings");
                  setProfileOpen(false);
                }}
              >
                Settings
              </span>

              <span
                className="logout"
                onClick={() => {
                  logout();
                  setProfileOpen(false);
                }}
              >
                Logout
              </span>
            </div>
          )}
        </div>

      </div>
    </header>
  );
};

export default AppHeader;
